import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import PageContainer from '../../common/components/PageContainer';

function AcessoNegado() {
  return (
    <PageContainer sx={{ maxWidth: 480 }}>
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <BlockOutlinedIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
          Acesso negado
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 4 }}>
          Você não tem permissão para acessar esta página. Se acha que isso é um erro, fale com o
          time de TI.
        </Typography>
        <Button component={Link} to="/feed" variant="contained" color="secondary">
          Voltar ao início
        </Button>
      </Box>
    </PageContainer>
  );
}

export default AcessoNegado;
